import { IAccountActions } from "@/account/account-actions";
import type { IPostRequest, IRequest } from "@/utils/async";
import { ERequestStatus, requestInit } from "@/utils/async";
import { createReducer } from "@reduxjs/toolkit";
import { IHeaderModalActions } from "./header-modal-actions";

export interface IHeaderModalModel {
  openHeaderMenuId: string;
  patchUpdateChatFavorite: IPostRequest<any, any>;
  patchUpdateChatRemoveFavorite: IPostRequest<any, any>;
  patchMuteChat: IPostRequest<any, any>;
  patchUnmuteChat: IPostRequest<any, any>;
  patchBlockUser: IPostRequest<any, any>;
  deleteBlockUser: IRequest<any>;
  patchBlockMedia: IPostRequest<any, any>;
  deleteBlockMedia: IRequest<any>;
  postChangeRate: IPostRequest<any, any>;
  patchReportUser: IPostRequest<any, any>;
  patchUpdateChatHide: IPostRequest<any, any>;
  patchUpdateChatUnhide: IPostRequest<any, any>;
  patchUpdateChatDelete: IPostRequest<any, any>;
  deleteFeedItem: IRequest<any>;
  // cancelSubscription: IRequest<any>;
  removeCard: IRequest<any>;
}

const INITIAL_STATE: IHeaderModalModel = {
  openHeaderMenuId: "",
  patchUpdateChatFavorite: requestInit(),
  patchUpdateChatRemoveFavorite: requestInit(),
  patchMuteChat: requestInit(),
  patchUnmuteChat: requestInit(),
  patchBlockUser: requestInit(),
  deleteBlockUser: requestInit(),
  patchBlockMedia: requestInit(),
  deleteBlockMedia: requestInit(),
  postChangeRate: requestInit(),
  patchReportUser: requestInit(),
  patchUpdateChatHide: requestInit(),
  patchUpdateChatUnhide: requestInit(),
  patchUpdateChatDelete: requestInit(),
  deleteFeedItem: requestInit(),
  // cancelSubscription: requestInit(),
  removeCard: requestInit(),
};

/** Reducer */
export const headerModalReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(IHeaderModalActions.resetOptions, (state, action: any) => {
      return {
        ...INITIAL_STATE,
        openHeaderMenuId: state.openHeaderMenuId,
      };
    })
    .addCase(IHeaderModalActions.toggleHeaderMenu, (state, action: any) => {
      return {
        ...state,
        openHeaderMenuId: action.payload.id,
      };
    })
    .addCase(
      IHeaderModalActions.initPatchUpdateChatFavorite,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatFavorite: {
            status: ERequestStatus.Fetching,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.successPatchUpdateChatFavorite,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatFavorite: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchUpdateChatFavorite,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatFavorite: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.initPatchUpdateChatRemoveFavorite,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatRemoveFavorite: {
            status: ERequestStatus.Fetching,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.successPatchUpdateChatRemoveFavorite,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatRemoveFavorite: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchUpdateChatRemoveFavorite,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatRemoveFavorite: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(IHeaderModalActions.initPatchBlockUser, (state, action: any) => {
      return {
        ...state,
        patchBlockUser: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(
      IHeaderModalActions.successPatchBlockUser,
      (state, action: any) => {
        return {
          ...state,
          patchBlockUser: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchBlockUser,
      (state, action: any) => {
        return {
          ...state,
          patchBlockUser: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(IHeaderModalActions.initDeleteBlockUser, (state, action: any) => {
      return {
        ...state,
        deleteBlockUser: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(
      IHeaderModalActions.successDeleteBlockUser,
      (state, action: any) => {
        return {
          ...state,
          deleteBlockUser: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failureDeleteBlockUser,
      (state, action: any) => {
        return {
          ...state,
          deleteBlockUser: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(IHeaderModalActions.initPatchBlockMedia, (state, action: any) => {
      return {
        ...state,
        patchBlockMedia: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(
      IHeaderModalActions.successPatchBlockMedia,
      (state, action: any) => {
        return {
          ...state,
          patchBlockMedia: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchBlockMedia,
      (state, action: any) => {
        return {
          ...state,
          patchBlockMedia: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(IHeaderModalActions.initDeleteBlockMedia, (state, action: any) => {
      return {
        ...state,
        deleteBlockMedia: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(
      IHeaderModalActions.successDeleteBlockMedia,
      (state, action: any) => {
        return {
          ...state,
          deleteBlockMedia: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failureDeleteBlockMedia,
      (state, action: any) => {
        return {
          ...state,
          deleteBlockMedia: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(IHeaderModalActions.initPostChangeRate, (state, action: any) => {
      return {
        ...state,
        postChangeRate: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(
      IHeaderModalActions.successPostChangeRate,
      (state, action: any) => {
        return {
          ...state,
          postChangeRate: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePostChangeRate,
      (state, action: any) => {
        return {
          ...state,
          postChangeRate: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(IHeaderModalActions.initPatchReportUser, (state, action: any) => {
      return {
        ...state,
        patchReportUser: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(
      IHeaderModalActions.successPatchReportUser,
      (state, action: any) => {
        return {
          ...state,
          patchReportUser: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchReportUser,
      (state, action: any) => {
        return {
          ...state,
          patchReportUser: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(IHeaderModalActions.initPatchMuteChat, (state, action: any) => {
      return {
        ...state,
        patchMuteChat: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(IHeaderModalActions.successPatchMuteChat, (state, action: any) => {
      return {
        ...state,
        patchMuteChat: {
          responseData: action.payload,
          status: ERequestStatus.Fetched,
        },
      };
    })
    .addCase(IHeaderModalActions.failurePatchMuteChat, (state, action: any) => {
      return {
        ...state,
        patchMuteChat: {
          error: action.payload,
          status: ERequestStatus.Error,
        },
      };
    })
    .addCase(IHeaderModalActions.initPatchUnmuteChat, (state, action: any) => {
      return {
        ...state,
        patchUnmuteChat: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(
      IHeaderModalActions.successPatchUnmuteChat,
      (state, action: any) => {
        return {
          ...state,
          patchUnmuteChat: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchUnmuteChat,
      (state, action: any) => {
        return {
          ...state,
          patchUnmuteChat: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.initPatchUpdateChatHide,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatHide: {
            status: ERequestStatus.Fetching,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.successPatchUpdateChatHide,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatHide: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchUpdateChatHide,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatHide: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.initPatchUpdateChatUnhide,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatUnhide: {
            status: ERequestStatus.Fetching,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.successPatchUpdateChatUnhide,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatUnhide: {
            responseData: action.payload.res,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchUpdateChatUnhide,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatUnhide: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.initPatchUpdateChatDelete,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatDelete: {
            status: ERequestStatus.Fetching,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.successPatchUpdateChatDelete,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatDelete: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failurePatchUpdateChatDelete,
      (state, action: any) => {
        return {
          ...state,
          patchUpdateChatDelete: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    .addCase(IHeaderModalActions.initDeleteFeedItem, (state, action: any) => {
      return {
        ...state,
        deleteFeedItem: {
          status: ERequestStatus.Fetching,
        },
      };
    })
    .addCase(
      IHeaderModalActions.successDeleteFeedItem,
      (state, action: any) => {
        const { res } = action.payload;
        return {
          ...state,
          deleteFeedItem: {
            responseData: res,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IHeaderModalActions.failureDeleteFeedItem,
      (state, action: any) => {
        return {
          ...state,
          deleteFeedItem: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    )
    // [IAccountActions.Type.DELETE__SUBSCRIPTION__INIT]: (state, action: any) => {
    //   return {
    //     ...state,
    //     cancelSubscription: {
    //       status: ERequestStatus.Fetching
    //     }
    //   };
    // },
    // [IAccountActions.Type.DELETE__SUBSCRIPTION__SUCCESS]: (state, action: any) => {
    //   return {
    //     ...state,
    //     cancelSubscription: {
    //       responseData: action.payload.res,
    //       status: ERequestStatus.Fetched
    //     }
    //   };
    // },
    // [IAccountActions.Type.DELETE__SUBSCRIPTION__FAILURE]: (state, action: any) => {
    //   return {
    //     ...state,
    //     cancelSubscription: {
    //       error: action.payload,
    //       status: ERequestStatus.Error
    //     }
    //   };
    // },
    .addCase(
      IAccountActions.initDeleteSavedCreditCard,
      (state, action: any) => {
        return {
          ...state,
          removeCard: {
            status: ERequestStatus.Fetching,
          },
        };
      }
    )
    .addCase(
      IAccountActions.successDeleteSavedCreditCard,
      (state, action: any) => {
        return {
          ...state,
          removeCard: {
            responseData: action.payload.res,
            status: ERequestStatus.Fetched,
          },
        };
      }
    )
    .addCase(
      IAccountActions.failureDeleteSavedCreditCard,
      (state, action: any) => {
        return {
          ...state,
          removeCard: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    );
});
